//components/DeleteMarksModal.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './DeleteMarksModal.module.css';

/**
 * Модальное окно для удаления марок:
 *  - по дате
 *  - по имени файла (ручной ввод или выбор через диалог)
 *  - по дате и имени файла
 */
const DeleteMarksModal = ({ onClose, onDelete }) => {
  const [date, setDate]           = useState('');
  const [filename, setFilename]   = useState('');
  const [fileObj, setFileObj]     = useState(null);

  const handleSubmit = () => {
    const name = fileObj?.name || filename;
    onDelete({ date, filename: name });
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h3 className={styles.title}>Удалить марки</h3>

        {/* Выбор даты */}
        <div className={styles.fieldGroup}>
          <label className={styles.label}>Дата:</label>
          <input
            type="date"
            className={styles.input}
            value={date}
            onChange={e => setDate(e.target.value)}
          />
        </div>

        {/* Ручной ввод имени файла */}
        <div className={styles.fieldGroup}>
          <label className={styles.label}>Имя файла:</label>
          <input
            type="text"
            placeholder="например, marks.csv"
            className={styles.input}
            value={filename}
            onChange={e => {
              setFilename(e.target.value);
              setFileObj(null);
            }}
          />
        </div>

        {/* Выбор файла через диалог */}
        <div className={styles.fieldGroup}>
          <label className={styles.label}>Выбрать файл:</label>
          <input
            type="file"
            accept=".csv"
            className={styles.inputFile}
            onChange={e => {
              const f = e.target.files[0];
              setFileObj(f || null);
              if (f) setFilename(f.name);
            }}
          />
          {fileObj && <span className={styles.fileName}>{fileObj.name}</span>}
        </div>

        <div className={styles.actions}>
          <button
            className={styles.buttonDanger}
            onClick={handleSubmit}
            disabled={!date && !filename}
          >
            Удалить
          </button>
          <button className={styles.button} onClick={onClose}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

DeleteMarksModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteMarksModal;